export function parseFontFamily(definition: string) {
  const match = definition.match(/font-family:\s*(['"]?)([^;'"]+)\1\s*;/);
  return match ? match[2].trim() : null;
}

export function getUniqueFontFamilies(
  fontFaceDefinitions: ReadonlyArray<string>
): Array<string> {
  const uniqueFontFamilies = new Set<string>();

  fontFaceDefinitions.forEach((definition) => {
    const fontFamily = parseFontFamily(definition);
    if (fontFamily) {
      uniqueFontFamilies.add(fontFamily);
    }
  });

  return Array.from(uniqueFontFamilies);
}
